module.exports = __webpack_public_path__ + "media/images/pc/inbound_guidance/link-bfc5e24d971b032015ed8d460fc3a109.svg";